module.exports = new __parcel__URL__("shield.93ee356a.png").toString();